import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FieldsetHarukiSelectOption } from '../fieldset-haruki/fieldset-haruki-select-option';

@Component({
  selector: 'mm-alice-keys-config',
  templateUrl: './alice-keys-config.component.html',
  styleUrls: ['./alice-keys-config.component.scss']
})
export class AliceKeysConfigComponent implements OnInit, OnChanges {

  @Input('forms') forms: UntypedFormArray;
  @Input('type') type: 'LICENSE' | 'CMS' = 'CMS';
  @Input('resetForms') resetForms: string;
  @Input('postgresConnectorOptions') postgresConnectorOptions: FieldsetHarukiSelectOption[] = [];

  @Output('removeForm') removeFormEmitter = new EventEmitter();
  @Output('formsChanged') formsChanged = new EventEmitter();
  @Output('openMediaPicker') openMediaPicker = new EventEmitter();
  @Output('testConnection') testConnection = new EventEmitter<UntypedFormGroup>();

  notToIndexTypeOptions: FieldsetHarukiSelectOption[] = [
    { label: 'Paginas', value: 'PAGES' },
    { label: 'Mídias', value: 'MEDIAS' },
  ]

  vetorialSearchOptions: FieldsetHarukiSelectOption[] = [
    { label: "Busca Vetorial Comum", value: "VETORIAL_INDEX_SEARCH" },
    { label: "Query Routing", value: "QUERY_ROUTING" }
  ]

  agentsEnabledOptions: FieldsetHarukiSelectOption[] = [
    { label: "Sim", value: "true" },
    { label: "Não", value: "false" }
  ]

  typeOptions: FieldsetHarukiSelectOption[] = [
    { label: 'Mensagem de Sistema', value: 'SYSTEM_MESSAGE' },
    { label: 'Conector Externo', value: 'EXTERNAL_CONNECTOR' },
    { label: 'Excluir Páginas do Index Vetorial', value: 'EXCLUDE_PAGES_FROM_INDEX' },
    { label: 'Não indexar', value: 'NOT_TO_INDEX' },
    { label: 'Avatar Assistente', value: 'ASSISTANT_AVATAR' },
    { label: 'Nome da Assistente', value: 'ASSISTANT_NAME' },
    { label: 'Perfis de acesso a Requisições a Alice', value: 'AI_REQUEST_GROUPS' },
    { label: 'Perfis de acesso a Requisições a Alice Reports', value: 'AI_REPORT_GROUPS' },
    { label: 'Busca relevante em todo o conteúdo', value: 'RELEVANT_SEARCH_IGNORE_HOMEPAGE' },
  ];

  externalConnectorTypeOptions: FieldsetHarukiSelectOption[] = [
    { label: 'Google Big Query', value: 'BIG_QUERY' },
    { label: 'PostgreSQL', value: 'POSTGRES' },
  ];

  postgresConnectorOptionsWithInternal: FieldsetHarukiSelectOption[] = [
    { label: 'Banco interno (CMS)', value: null },
  ];

  constructor(
    private formBuilder: UntypedFormBuilder
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.resetForms && changes.resetForms.currentValue) {
      let value = changes.resetForms.currentValue;
      this.resetForm(value);
    }
    if (changes.postgresConnectorOptions) {
      this.postgresConnectorOptionsWithInternal = [
        { label: 'Banco interno (CMS)', value: null },
        ...this.postgresConnectorOptions,
      ];
    }
  }

  ngOnInit() {
    if (this.type === 'LICENSE') {
      this.typeOptions.push(
        { label: 'Definição de tabela', value: 'TABLE_DEFINITION' },
        { label: 'Modelo LLM', value: 'MODEL' },
        { label: 'Modelo de Embedding', value: 'MODEL_EMBEDDING' },
        { label: 'Tamanho máximo dos segmentos de indexação', value: 'DOCUMENT_SPLITTER_SEGMENT_SIZE' },
        { label: 'Dimensão do index', value: 'INDEX_DIMENSION' },
        { label: 'Quantidade de items na busca', value: 'SEARCH_RESULTS_SIZE' },
        { label: 'Modelo de LLM mais barato', value: 'CHEAPER_MODEL' },
        { label: 'Modelo de Ferramentas', value: 'TOOLS_MODEL' },
        { label: 'Modelo de Geração de Imagens', value: 'MODEL_IMAGE' },
        { label: 'Tipo de Busca vetorial', value: 'VETORIAL_SEARCH_TYPE' },
        { label: 'Utilizar Agentes', value: 'AGENTS_ENABLED' },
        { label: 'Alice — Analisar imagens em PDFs (OCR)', value: 'OCR_PDF_ENABLED' },
      );
    } else if (this.type === 'CMS') {
      this.typeOptions.splice(2, 0, { label: 'Definição de tabela', value: 'TABLE_DEFINITION' });
    }
  }
  addNew() {
    this.forms.insert(0, this.formBuilder.group({
      name: ['', Validators.required],
      value: ['', Validators.required],
      type: ['SYSTEM_MESSAGE', Validators.required],
      referencedConnectorId: [null],
      externalConnector: this.formBuilder.group({
        type: [null, Validators.required],
        datasetName: null,
        datasetDescription: null,
        googleCloudApiKey: null,
        googleCloudProjectId: null,
        host: null,
        port: 5432,
        databaseName: null,
        schemaName: 'public',
        username: null,
        password: null,
        description: null,
        sslEnabled: false
      })
    }));
  }

  removeForm(index: number) {
    this.removeFormEmitter.emit(index);
  }

  resetForm(type: string) {
    this.forms.controls.forEach((form: UntypedFormGroup) => {
      if (form.get('type').value === type) {
        form.reset();
      }
    })
  }

  validateShowValueField(type: string) {
    return !(
      type === 'EXTERNAL_CONNECTOR' ||
      type === 'EXCLUDE_PAGES_FROM_INDEX' ||
      type === 'NOT_TO_INDEX' ||
      type === 'ASSISTANT_AVATAR' ||
      type === 'VETORIAL_SEARCH_TYPE' ||
      type === 'AGENTS_ENABLED' ||
      type === 'OCR_PDF_ENABLED' ||
      type === 'ASSISTANT_NAME' ||
      type === 'AI_REQUEST_GROUPS' ||
      type === 'AI_REPORT_GROUPS' ||
      type === 'RELEVANT_SEARCH_IGNORE_HOMEPAGE'
    )
  }

  validateShowNameField(type: string) {
    return !(
      type === 'EXTERNAL_CONNECTOR' ||
      type === 'VETORIAL_SEARCH_TYPE' ||
      type === 'AGENTS_ENABLED' ||
      type === 'OCR_PDF_ENABLED' ||
      type === 'NOT_TO_INDEX' ||
      type === 'RELEVANT_SEARCH_IGNORE_HOMEPAGE'
    )
  }

  emitOpenMediaPicker(form: UntypedFormGroup) {
    this.openMediaPicker.emit(form);
  }

  emitTestConnection(form: UntypedFormGroup) {
    this.testConnection.emit(form);
  }
}
